import styled, { css } from "styled-components";
import { OrderItemProcessStatus } from "../../../../../enums/Orders";

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;
  }
`;

export const SumaryContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  gap: 1rem;
`;

export const AlignDataContainer = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    justify-content: space-between;
  }
`;

export const SumaryDataTitle = styled.p`
  font-weight: ${(props) => props.theme.fontWeight.Bold};
  color: ${(props) => props.theme.newColors["gray-900"]};
  width: 12rem;
  line-height: 1.4;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    width: 9rem;
  }
`;

export const SumaryData = styled.div`
  color: ${(props) => props.theme.newColors["black-900"]};
  line-height: 1.4;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    justify-content: flex-end;
    width: 50%;
  }
`;

export const ShipmentsContainer = styled.div`
  margin: 1.5rem 0;
`;

export const ProductListsTitle = styled.h3`
  color: ${(props) => props.theme.colors["gray-850"]};
  font-size: ${(props) => props.theme.fontSize.XS};
  font-weight: ${(props) => props.theme.fontWeight.Semibold};
  margin-bottom: 1.5rem;
`;

export const NumberOfProducts = styled.span`
  color: ${(props) => props.theme.colors["gray-850"]};
`;

interface StatusContainerProps {
  variant: keyof typeof OrderItemProcessStatus | "Completed" | "otherwise";
}

export const StatusContainer = styled.div<StatusContainerProps>`
  display: inline-block;
  padding: 0 0.75rem;
  border-radius: ${(props) => props.theme.borderRadius.XXLG};

  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;

  color: ${(props) => props.theme.colors["black-925"]};
  background-color: ${(props) => props.theme.colors["red-425"]};

  ${(props) =>
    (props.variant === "CANCELLED" || props.variant === "CANCELED") &&
    css`
      background-color: ${(props) => props.theme.colors["gray-700"]};
    `};

  ${(props) =>
    props.variant === "ERROR" &&
    css`
      background-color: ${(props) => props.theme.colors["red-475"]};
    `};

  ${(props) =>
    props.variant === "NEW" &&
    css`
      background-color: ${(props) => props.theme.colors["cyan-200"]};
    `};

  ${(props) =>
    props.variant === "otherwise" &&
    css`
      background-color: ${(props) => props.theme.colors["gray-600"]};
    `};

  ${(props) =>
    props.variant === "PENDING" &&
    css`
      background-color: ${(props) => props.theme.colors["golden-500"]};
    `};

  ${(props) =>
    props.variant === "PICKED" &&
    css`
      background-color: ${(props) => props.theme.colors["green-650"]};
    `};

  ${(props) =>
    props.variant === "PICKING" &&
    css`
      background-color: ${(props) => props.theme.colors["blue-675"]};
      color: ${(props) => props.theme.colors.white};
    `};

  ${(props) =>
    props.variant === "PARTIALLY_PICKED" &&
    css`
      background-color: ${(props) => props.theme.colors["orange-450"]};
    `};

  ${(props) =>
    props.variant === "SHIPPED" &&
    css`
      background-color: ${(props) => props.theme.colors["green-800"]};
      color: ${(props) => props.theme.colors.white};
    `};

  ${(props) =>
    props.variant === "SUCCESS" &&
    css`
      background-color: ${(props) => props.theme.colors["green-550"]};
    `};

  ${(props) =>
    props.variant === "Completed" &&
    css`
      background-color: ${(props) => props.theme.colors["green-550"]};
    `};
`;

export const NotesContainerAlign = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const NotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 2.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin: 0;

    div {
      justify-content: flex-start;
    }
  }
`;

export const ActivityTextArea = styled.textarea`
  width: 100%;
  height: 15rem;

  padding: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;

  border-color: ${(props) => props.theme.colors["gray-400"]};
  border-radius: 0.5rem;
  color: ${(props) => props.theme.colors["black-925"]};

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    height: 4.5rem;
    margin: 0;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors["gray-700"]};
  }

  &:disabled {
    opacity: 1;
    background-color: ${(props) => props.theme.colors.white};
  }
`;

export const BillingText = styled.p`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  color: ${(props) => props.theme.colors["gray-850"]};
`;

export const DropshipQtyText = styled.p<{ color: string }>`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  color: ${(props) => props.color ?? props.theme.colors["gray-850"]};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
`;
